import { Order } from "common-ts/dist/models/Orders";
import { useAppSelector } from "../reduxhooks";
import { Box, createStyles, IconButton, makeStyles, Typography } from "@material-ui/core";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { FareastButton } from "./OverlayComponentButton";
import React from "react";
import { useLocation } from "react-router-dom";

const useStyles = makeStyles(() =>
    createStyles({
        arrowBackButton: {
            color: "black",
            padding: "0 0 15px 0",
        },
        title: {
            fontWeight: 600,
            fontSize: "1.2rem",
        },
        keterangan: {
            fontSize: "0.75rem",
            fontWeight: 300,
            color: '#454545',
            marginTop: "8px",
            marginBottom: "26px",
        },
        orderContainer: {
            display: "flex",
            flexDirection: "column",
        },
        orderItem: {
            border: "1px solid rgb(221, 221, 221)",
            borderRadius: "17px",
            padding: "15px",
            marginBottom: "15px",
        },
        orderTextContainer: {
            marginBottom: "15px",
        },
        text: {
            fontSize: "0.7rem",
            fontWeight: 500,
        },
        buttonContainer: {
            width: "100%",
            marginTop: "5px",
            textAlign: "right",
        },
    })
);

function createDate(isoString: string): string {
    const date = new Date(isoString);
    return date.toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
    });
}

interface Props {
    handleBack: () => void;
    handleNext: () => void;
    setSelectedOrder: (selectedOrder: Order) => void;
}

export function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function OrderSelect({ handleBack, handleNext, setSelectedOrder }: Props) {
    let query = useQuery();
    const classes = useStyles();
    const ordersList = useAppSelector((state) => state.ordersList.ordersList);
    const userOrderCount = useAppSelector((state) => state.account.paidOrderCount);
    const sortedOrders = [...ordersList].sort((a, b) => new Date(b.creationDateTime).getTime() - new Date(a.creationDateTime).getTime());

    function chooseOrder(order: Order) {
        setSelectedOrder(order);
        handleNext();
    }

    return (
        <Box style={{margin: '6px 0px 60px 0px'}}>
            {userOrderCount > 0 ? (
                <>
                    <Typography className={classes.title} style={{marginTop: '21px'}}>Pilih Order Yang Ingin Kamu Proses</Typography>
                    <Typography className={classes.keterangan}>Kamu bisa meminta penukaran size, servis atau komplain <span style={{fontWeight: 500, color: '#070707'}}>maksimal 1 bulan</span> setelah tanggal order.</Typography>

                    {sortedOrders.filter((order: Order) => (order.paymentStatus === "capture" || order.paymentStatus === "settlement" || order.paymentStatus === "capture_marketplace"))
                    .map((order: Order) => {
                        const buttonDisabled = new Date() > new Date(new Date(order.creationDateTime).setMonth(new Date(order.creationDateTime).getMonth() + 1))
                        && !(query.get("userpass") === "kecoatidur");

                        return (
                            <Box key={order.orderId} className={classes.orderContainer}>
                                <Box className={classes.orderItem}>
                                    <Box className={classes.orderTextContainer}>
                                        <Typography className={classes.text}
                                        style={{fontWeight: 300, color: '#565656', fontSize: '12px'}}
                                        >Order ID</Typography>
                                        <Typography style={{ fontSize: "13px", fontWeight: 500 }}>{order.orderId}</Typography>
                                    </Box>
                                    <Box className={classes.orderTextContainer}>
                                        <Typography className={classes.text} style={{fontWeight: 300, color: '#565656', fontSize: '11px'}}>Tanggal Order</Typography>
                                        <Typography style={{ fontSize: "0.75rem", fontWeight: 600}}>{createDate(order.creationDateTime)}</Typography>
                                    </Box>
                                    <Box className={classes.buttonContainer}>
                                        <FareastButton
                                            style={{ cursor: "pointer" }}
                                            buttonMarginLeftRight="auto"
                                            buttonMarginTopBottom="0px"
                                            onClick={() => {
                                                chooseOrder(order);
                                            }}
                                            disabled={buttonDisabled}
                                        >
                                            {buttonDisabled ? "ORDER SUDAH LEWAT" : "PILIH ORDER"}
                                        </FareastButton>
                                    </Box>
                                </Box>
                            </Box>
                        );
                    })}
                </>
            ) : (
                <>
                    <Typography className={classes.title}>Kamu Belum Memiliki Pembelian</Typography>
                    <Typography className={classes.keterangan}>Lakukan pembelian dan kamu bisa mengajukan Tukar Size atau Servis maks. 1 bulan setelah order.</Typography>
                </>
            )}
        </Box>
    );
}
